import { z } from "zod";

import { zodResolver } from "@hookform/resolvers/zod";

import { PROGRAM_TYPE_OPTIONS } from "containers/admin/clients/client/campaign-templates-page/campaign-template.constants";

export const TOTAL_CAMPAIGN_WITH_WRITER_STEPS = 4;
export const CAMPAIGN_DETAILS_STEP = 3;

export const PROGRAM_STRATEGY_OPTIONS = PROGRAM_TYPE_OPTIONS.map(({ label, value }) => ({
  label,
  value,
}));

export const CAMPAIGN_TEMPLATE_HELPER_TEXT = "Available after program strategy is selected.";

export const CREATE_CAMPAIGN_WITH_WRITER_SCHEMA = zodResolver(
  z.object({
    transferStudentStatusFlag: z.boolean().default(false),
    programStrategy: z.string().min(1, "Program strategy is required"),
    campaignTemplateId: z.string().min(1, "Campaign template is required"),
    includeCreatives: z.boolean().default(false),
    deliverables: z.array(z.string()).default([]),
    campaignName: z
      .string()
      .min(1, "Campaign name is required")
      .refine((val) => val.trim().length > 0, {
        message: "Campaign name cannot be empty or only whitespace.",
      }),
    cdnSubdirectoryName: z
      .string()
      .optional()
      .refine(
        (val) => {
          if (val === undefined || val === "") return true;
          return /^[a-zA-Z0-9_-]*$/.test(val);
        },
        {
          message:
            "CDN profile name can only contain letters, numbers, underscores, and dashes (no spaces or special characters).",
        },
      ),
    emailAdditionalInstructions: z.string().optional(),
  }),
);
